export default function initMap() {
  ymaps.ready(init);

  function init() {
    var myMap = new ymaps.Map("map", {
      center: [55.69558056903058, 37.421847500000005],
      zoom: 15,
      suppressMapOpenBlock: false
    });

    const myPlacemark = new ymaps.Placemark([55.69558056903058, 37.421847500000005]);
    myMap.geoObjects.add(myPlacemark);
    myMap.behaviors.disable('scrollZoom')
    myMap.controls.remove('searchControl')
      .remove('routeButtonControl')
      .remove('trafficControl')
      .remove('geolocationControl')
      .remove('typeSelector')

  }
}